/**
 * The concerns a citizen can raise in the Care assessment — one vocabulary,
 * and the words for each, so the citizen's plan and the company's drawer name
 * a concern the same way (the drawer printed the raw slug, "housing", in every
 * language).
 *
 * @module heroes/care
 */
export const CARE_CONCERNS = [
  'family',
  'finances',
  'healthcare',
  'housing',
  'language',
  'loneliness',
  'schooling',
  'work',
] as const;
export type CareConcern = (typeof CARE_CONCERNS)[number];

export const CARE_CONCERN_LABEL_KEY = {
  family: 'care.concern.family',
  finances: 'care.concern.finances',
  healthcare: 'care.concern.healthcare',
  housing: 'care.concern.housing',
  language: 'care.concern.language',
  loneliness: 'care.concern.loneliness',
  schooling: 'care.concern.schooling',
  work: 'care.concern.work',
} as const satisfies Record<CareConcern, string>;

export function isCareConcern(value: string): value is CareConcern {
  return (CARE_CONCERNS as readonly string[]).includes(value);
}
